// Novedades de epms: lo que cambió para los usuarios, por versión. Es la única
// fuente: de acá salen la ventana "Novedades" que aparece al entrar, los
// globitos "Nuevo" del menú y el historial de cambios de la Ayuda.
//
// Cada cambio que se note en las pantallas suma una entrada ARRIBA (la más
// nueva primero), con la fecha del despliegue. `menu` es la ruta del menú que
// lleva el globito; `ir`, adónde manda el botón de la ventana; `ayuda`, la
// sección del manual que lo explica.

export interface Novedad {
  titulo: string;
  texto: string;
  menu?: string;
  ir?: string;
  ayuda?: string;
}

export interface Version {
  /** Fecha del despliegue, 'AAAA-MM-DD'. */
  fecha: string;
  novedades: Novedad[];
}

export const VERSIONES: Version[] = [
  {
    fecha: '2026-10-29',
    novedades: [
      {
        titulo: 'Notas de crédito como en la DDJJ de IVA',
        texto: 'Conciliar suma las NC recibidas al débito (restitución de crédito fiscal) y las NC emitidas al crédito (restitución de débito fiscal), como la DDJJ. El detalle muestra las cuatro líneas y avisa las NC y ND en moneda extranjera para revisar.',
        menu: '/conciliar', ir: '/conciliar', ayuda: 'conciliar',
      },
      {
        titulo: 'Subdiarios de IVA de Tango',
        texto: 'Los listados de ventas y compras de Tango se leen solos para el cruce comprobante por comprobante: junta las alícuotas, separa las percepciones y reconoce las NC y ND (también las de diferencia de cambio).',
        ayuda: 'conciliar',
      },
      {
        titulo: 'Cruce en pesos y por tipo',
        texto: 'El cruce comprobante por comprobante pasa a pesos las facturas en moneda extranjera de Mis Comprobantes, así coinciden con el listado del sistema. Y si el tipo no coincide (Tango no distingue recibo, tique o liquidación de una factura) igual los empareja, marcados como "Tipo distinto".',
        menu: '/conciliar', ayuda: 'conciliar',
      },
      {
        titulo: 'Archivos que llegan en blanco',
        texto: 'Si un archivo llega todo en ceros (pasa al subir desde iCloud o OneDrive uno que no estaba descargado en la compu), no se guarda y te avisa que lo vuelvas a subir.',
        ayuda: 'archivos',
      },
    ],
  },
  {
    fecha: '2026-10-28',
    novedades: [
      {
        titulo: 'Sin aviso por usuarios sin clave fiscal',
        texto: 'Las cintas ya no avisan de usuarios que no cargaron su clave fiscal (hay usuarios que el robot no usa). Sí siguen avisando cuando ARCA rechaza una clave cargada.',
        ayuda: 'cintas',
      },
    ],
  },
  {
    fecha: '2026-10-27',
    novedades: [
      {
        titulo: 'Ayuda y novedades',
        texto: 'Un manual de uso de cada pantalla (el botón "?" de arriba abre la parte de la pantalla en la que estás) y esta ventana, que avisa lo nuevo de cada versión.',
        menu: '/ayuda', ir: '/ayuda', ayuda: 'primeros-pasos',
      },
      {
        titulo: 'Mi día',
        texto: 'La pantalla de inicio muestra lo que pide acción (vencimientos de la semana, DDJJ sin presentar, deuda vencida, proveedores a revisar) y lo que vence en 7 días, con importe cuando ARCA ya lo registra.',
        menu: '/inicio', ir: '/inicio', ayuda: 'mi-dia',
      },
      {
        titulo: 'Control de proveedores',
        texto: 'Cumplimiento › Proveedores cruza Mis Comprobantes recibidos con la base de facturas apócrifas de ARCA (APOC) y con el padrón: avisa facturas de proveedores apócrifos y facturas A de quien no es responsable inscripto.',
        menu: '/cumplimiento', ir: '/cumplimiento?solapa=proveedores', ayuda: 'cumplimiento',
      },
      {
        titulo: 'Borrador del Libro IVA Digital',
        texto: 'Conciliar › Libro IVA vs ARCA arma los cuatro TXT del Libro IVA Digital de un mes con Mis Comprobantes, para revisar e importar en el Portal IVA.',
        menu: '/conciliar', ir: '/conciliar', ayuda: 'conciliar',
      },
      {
        titulo: 'Saldos arrastrados y Ganancias',
        texto: 'Conciliar controla que cada DDJJ de IVA traiga bien los saldos a favor del mes anterior, y suma una solapa con las retenciones y percepciones de Ganancias de cada ejercicio.',
        menu: '/conciliar', ir: '/conciliar', ayuda: 'conciliar',
      },
      {
        titulo: 'Ficha del cliente en solapas',
        texto: 'Resumen, situación en ARCA, documentación y archivos, cada uno en su solapa.',
        menu: '/clientes', ir: '/clientes', ayuda: 'clientes',
      },
      {
        titulo: 'Antivirus',
        texto: 'Todo lo que suben o mandan por mail los clientes pasa por un antivirus. Lo infectado no se guarda.',
        ayuda: 'archivos',
      },
      {
        titulo: 'Cintas de una línea, y se ocultan por más tiempo',
        texto: 'Cada cinta roja ocupa una sola línea (pasá el mouse para ver el texto completo), y la X deja ocultarla por 24 horas, 48 horas, 7 días o 1 mes (vuelve antes si cambia lo que avisa).',
        ayuda: 'cintas',
      },
      {
        titulo: 'Desde el celular',
        texto: 'Las pantallas principales se adaptan al celular; las alertas se pliegan en una barra roja que se despliega.',
      },
    ],
  },
  {
    fecha: '2026-10-26',
    novedades: [
      {
        titulo: 'Informe mensual al cliente en PDF',
        texto: 'Desde la ficha del cliente, el botón "Informe mensual" arma un PDF con facturación, IVA o Monotributo, vencimientos, deudas y planes, con observaciones del estudio.',
        menu: '/clientes', ir: '/clientes', ayuda: 'informe-mensual',
      },
      {
        titulo: 'Deuda vencida y a vencer',
        texto: 'La Cuenta tributaria separa lo vencido de lo que ARCA ya registra pero todavía no vence (IVA diferido, anticipos).',
        ayuda: 'cumplimiento',
      },

      {
        titulo: 'Cumplimiento',
        texto: 'Por cliente e impuesto: DDJJ sin presentar, deuda, última DDJJ y próximo vencimiento según ARCA, planes de pago, DFE y el control de Monotributo con la próxima recategorización.',
        menu: '/cumplimiento', ir: '/cumplimiento', ayuda: 'cumplimiento',
      },
      {
        titulo: 'Cintas rojas de alerta',
        texto: 'Arriba de todas las pantallas, lo que pide acción ya sobre tus clientes. La X las oculta por un tiempo.',
        ayuda: 'cintas',
      },
      {
        titulo: 'Conciliar',
        texto: 'La DDJJ de IVA contra Mis Comprobantes y Mis Retenciones, mes por mes, y el Libro IVA del cliente contra ARCA, comprobante por comprobante.',
        menu: '/conciliar', ir: '/conciliar', ayuda: 'conciliar',
      },
    ],
  },
];

export const ULTIMA_VERSION = VERSIONES[0]!.fecha;

/** Días que un menú lleva el globito "Nuevo" después de una versión. */
export const DIAS_GLOBITO = 21;

/** Las versiones que el usuario no vio (si nunca vio ninguna, las del último mes). */
export function versionesSinVer(vistas: string | null, hoy = new Date()): Version[] {
  if (vistas) return VERSIONES.filter((v) => v.fecha > vistas);
  const desde = new Date(hoy.getTime() - 30 * 86_400_000).toISOString().slice(0, 10);
  return VERSIONES.filter((v) => v.fecha >= desde);
}

const CLAVE_VISITA = (ruta: string) => `epms:visita:${ruta}`;

/** Menús con novedad reciente que el usuario todavía no abrió desde esa versión. */
export function menusNuevos(hoy = new Date()): Set<string> {
  const desde = new Date(hoy.getTime() - DIAS_GLOBITO * 86_400_000).toISOString().slice(0, 10);
  const r = new Set<string>();
  for (const v of VERSIONES.filter((x) => x.fecha >= desde)) {
    for (const n of v.novedades) {
      if (!n.menu) continue;
      let visita: string | null = null;
      try { visita = localStorage.getItem(CLAVE_VISITA(n.menu)); } catch { /* sin almacenamiento */ }
      if (!visita || visita < v.fecha) r.add(n.menu);
    }
  }
  return r;
}

/** Anota que el usuario abrió ese menú (el globito se apaga). */
export function anotarVisita(ruta: string): void {
  try { localStorage.setItem(CLAVE_VISITA(ruta), new Date().toISOString().slice(0, 10)); } catch { /* sin almacenamiento */ }
}
